// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-settings-page-form {
    display: flex;
    gap: 1.25rem 1rem;
    margin: 0 auto;
    width: 95%;
    flex-wrap: wrap;
    padding-top: 2rem;
}

.user-settings-button-container {
    display: flex;
    justify-content: center;
    column-gap: 0.5rem;
    padding-top: 4rem;
}

.user-settings-line-break {
    flex-basis: 100%;
}

.user-settings-page-button {
    width: 100px;
}

@media (min-width: 600px) {
    .user-settings-page-form {
        width: 90%;
    }

    .user-settings-page-button {
        width: 130px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/userSettings/UserSettings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".user-settings-page-form {\n    display: flex;\n    gap: 1.25rem 1rem;\n    margin: 0 auto;\n    width: 95%;\n    flex-wrap: wrap;\n    padding-top: 2rem;\n}\n\n.user-settings-button-container {\n    display: flex;\n    justify-content: center;\n    column-gap: 0.5rem;\n    padding-top: 4rem;\n}\n\n.user-settings-line-break {\n    flex-basis: 100%;\n}\n\n.user-settings-page-button {\n    width: 100px;\n}\n\n@media (min-width: 600px) {\n    .user-settings-page-form {\n        width: 90%;\n    }\n\n    .user-settings-page-button {\n        width: 130px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
